<template>
    <div class="input-group-append">

        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Importação
                            <span v-if="is_excluir" class="text-danger ml-2">(Exclusão)</span>
                            {{ titulo }}
                        </h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!campos || refreshing" />

                        <div v-else>

                            <div class="form-row mb-3">
                                <div class="col col-12 col-md-2">
                                    <button type="button" class="btn btn-primary" @click="upload()">
                                        <i class="fas fa-plus mr-2"></i>
                                        Arquivo
                                    </button>
                                </div>

                                <div class="col col-12 col-md-2" v-if="layouts && layouts.length">
                                    <az-input
                                        type="select"
                                        placeholder="Layout..."
                                        :optionsList="layouts"
                                        v-model="layout_selecionado"
                                        @input="selecionar_layout" />
                                </div>

                                <template v-if="!layout_selecionado || layout_selecionado.ch_tipo === '0'">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            type="checkbox-group"
                                            label="Arquivo com cabeçalho das colunas"
                                            v-model="linha_titulos" />
                                    </div>

                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            type="select"
                                            label="Separador"
                                            :compact="true"
                                            placeholder="ponto-e-vírgula"
                                            :optionsList="[
                                                { id: ',', search: 'vírgula' },
                                            ]"
                                            v-model="separador" />
                                    </div>
                                </template>
                            </div>

                            <pre v-if="false">{{ layout_selecionado }}</pre>

                            <template v-if="info_parms && info_parms.length">
                                <div class="form-row mb-3" v-for="(parm, ipx) in info_parms" :key="ipx">
                                    <div class="col-12">
                                        <az-input
                                            :label="parm.display"
                                            placeholder="Selecionar..."
                                            :service="parm.service"
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            :optionsName="'import-' + parm.service"
                                            :optionsParm="{ ativos: true }"
                                            required
                                            :validate="validate"
                                            v-model="parm.valor" />
                                    </div>
                                </div>
                            </template>

                            <template v-if="layout_selecionado && layout_selecionado.ch_tipo !== '0'">
                                <div class="alert alert-info">
                                    Layout de importação selecionado: <strong>{{ layout_selecionado.st_titulo }}</strong>
                                </div>

                                <div v-if="is_layout_csv">CSV</div>
                                <div v-if="is_layout_xml">XML</div>

                                <br><br><br><br><br><br><br><br>
                            </template>

                            <template v-else>

                                <table class="table" v-if="!refreshing">
                                    <thead>
                                        <tr>
                                            <th>Campo</th>
                                            <th>Coluna do Arquivo</th>
                                            <th>Exemplo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(campo, icx) in campos" :key="icx">
                                            <td>
                                                {{ campo.display }}
                                            </td>
                                            <td>
                                                <az-input
                                                    v-if="cabecalhos && cabecalhos.length"
                                                    placeholder="Coluna do Arquivo..."
                                                    type="select"
                                                    :optionsList="cabecalhos"
                                                    optionsData="id"
                                                    optionsDisplay="search"
                                                    v-model="campo.coluna" />

                                                <az-input
                                                    v-else
                                                    placeholder="Coluna do Arquivo..."
                                                    v-model="campo.coluna" />
                                            </td>
                                            <td>
                                                <small class="text-muted">
                                                    {{ exemplo(campo) }}
                                                </small>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </template>
                        </div>

                        <slot name="instrucao"></slot>
                        <pre v-if="false" class="alert alert-info mt-3">{{ campos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                        <az-submit :color="is_excluir ? 'danger' : 'success'" @click="confirmar()" :disabled="!origem">Confirmar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" :id="modal_name + 'log'" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Log de Importação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul class="list-group">
                            <li class="list-group-item" v-for="(log, ilx) in logs" :key="ilx">{{ log }}</li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Dispatch -->
        <az-dispatch
            ref="dispatchModal"
            :name="modal_name"
            titulo="Importando arquivo..."
            @refresh="refresh_importacao()"
            @chunkRefresh="refresh_chunk" />

        <slot name="button-pre"></slot>

        <button :class="is_excluir ? 'btn btn-outline-danger' : 'btn btn-outline-secondary'" type="button" :id="'button-addon2-' + modal_name" @click="iniciar_importacao()"
            v-if="!hide" data-toggle="tooltip" data-placement="top" :title="is_excluir ? 'Excluir itens' : 'Importar'">
            <i class="fas fa-upload fa-fw"></i>
            <slot name="button-title"></slot>
        </button>

        <slot name="button-pos"></slot>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import * as CSV from 'csv-string';
import AzDispatch from "../../util/AzDispatch.vue";

export default {
    data() {
        return {
            origem: null,
            campos: null,
            linha_titulos: false,
            logs: [],
            separador: "",
            info_parms: [], 
            validate: false, 
            layouts: [], 
            layout_selecionado: "", 
            refreshing: false,
            excluir_colunas_esperadas: 10,
        }
    },

    components: {
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzDispatch,
    },

    props: ['service', 'parms', 'hide', 'titulo', 'chunk_size', 'excluir'],

    computed: {
        is_excluir: function () {
            return this.excluir === true || this.excluir === 'true';
        },

        is_layout_csv: function () { 
            if ( this.layout_selecionado && this.layout_selecionado.ch_tipo !== '0' )
                return false;

            return true;
        },

        is_layout_xml: function () { 
            if ( this.layout_selecionado && this.layout_selecionado.ch_tipo === 'S' )
                return true;

            return false;
        },

        modal_name: function () {
            const tipo = this.is_excluir ? 'Excluir' : 'Importar';
            return 'importModal' + this.service + tipo + this._uid;
        }, 

        cabecalhos: function () {
            if ( !this.linha_titulos || !this.origem )
                return null;

            let info;
            let campo = this.campos.find(campo => campo.coluna || campo.coluna === 0);

            if ( !campo ) { 
                
                info = _.first(this.origem);

            } else { 
            
                let index = this.get_index(campo);

                if ( index === null )
                    return null;

                info = this.origem.find(item => item[index]);

                if ( !info )
                    return null;

            }

            let chaveNumero = ( this.campos && this.campos.length && !isNaN(this.campos[0].coluna) ) ? true : false;

            //console.log('campos', this.campos);
            //console.log('CN', chaveNumero);

            return info.map((item, chave) => {
                    return {
                        id: chaveNumero ? chave : String.fromCharCode(65 + chave),
                        search: item,
                    };
                })
                .filter(item => item.search);
        },
    },

    methods: {
        selecionar_layout (layout) { 
            if ( layout && layout.id_importacao_layout ) { 

                if ( layout.ch_tipo === "0" ) { 
                    this.campos.forEach(campo => {
                        let campo_layout = layout.st_campos_json.find(campo_layout => campo_layout.campo.campo == campo.campo);
                        campo.coluna = campo_layout ? campo_layout.pos : '';
                    });         
                }

            }
        },

        fechar_modal() {
            $('#' + this.modal_name).modal('hide');
        },

        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        confirmar() {
            this.logs = [];

            const parms = this.parms ? this.parms : {};

            if ( this.is_excluir && !this.validar_colunas_exclusao(this.origem) ) {
                return;
            }

            if(this.linha_titulos && this.is_layout_csv) { 
                this.origem.shift();
            }

            this.$refs.dispatchModal.executar_chunck(
                this.service,
                "importar" + (this.is_excluir ? '_excluir' : ''),
                this.origem,
                'csv',
                {
                    campos: this.campos,
                    linha_titulos: false,
                    ...parms,
                    ...(this.is_excluir ? { excluir: true } : {}),
                    info_parms: this.info_parms,
                    id_importacao_layout: this.layout_selecionado ? this.layout_selecionado.id_importacao_layout : null,
                },
                this.chunk_size ? this.chunk_size : 100
            );
        },

        refresh_chunk(res) {
             if ( res && Array.isArray(res) ) {
                this.logs = this.logs.concat(res);
            }
        },

        refresh_importacao() {
            $('#' + this.modal_name).modal('hide');

            if ( this.logs && this.logs.length ) {
                $('#' + this.modal_name + 'log').modal('show');
            } else {
                this.$toast.add({
                    severity: "success",
                    summary: "Atenção",
                    detail: "Arquivo importado com sucesso.",
                    life: 3000
                });
            }

            this.$emit('refresh');
        },

        iniciar_importacao () {
            this.$emit('iniciar');

            this.origem = null;
            this.validate = false; 

            $('#' + this.modal_name).modal('show');

            if ( !this.campos ) {
                this.$util.load(this, {
                    service: this.service,
                    func: 'campos_importacao',
                    redir_api: true, 
                    parms: { 
                        ...this.parms,
                        layouts: true, 
                        ...(this.is_excluir ? { excluir: true } : {}),
                    }, 
                    loadTo: res => {
                        this.campos = res.campos.filter(campo => campo.coluna != 'SEL');
                        this.info_parms = res.campos.filter(campo => campo.coluna == 'SEL');
                        this.layouts = res.layouts;
                    }
                });
            }
        },

        get_index(campo) {
            let index;

            if ( !isNaN(campo.coluna) ) {
                index = campo.coluna;
            } else {
                index = campo.coluna.toUpperCase().charCodeAt(0) - 65;
            }

            if ( isNaN(index) || index < 0 )
                return null;

            return index;
        },

        cabecalhos2 () {
            if ( !this.linha_titulos || !this.origem )
                return null;

            let campo = this.campos.find(campo => campo.coluna);

            if ( !campo )
                return null;

            let index = this.get_index(campo);

            if ( index === null )
                return null;

            let info = this.origem.find(item => item[index]);

            if ( !info )
                return null;

            let chaveNumero = ( this.campos && this.campos.length && !isNaN(this.campos[0].coluna) ) ? true : false;

            //console.log('campos', this.campos);
            //console.log('CN', chaveNumero);

            return info.map((item, chave) => {
                    return {
                        id: chaveNumero ? chave : String.fromCharCode(65 + chave),
                        search: item,
                    };
                })
                .filter(item => item.search);
        },

        exemplo (campo) {
            if ( !this.origem )
                return null;

            if ( !campo || ( !campo.coluna && campo.coluna !== 0 ) )
                return null;

            let index = this.get_index(campo);

            if ( index === null )
                return null;

            let info = this.origem.find(
                (item, iix) =>
                    item[index]
                    && ( !this.linha_titulos || iix > this.origem.findIndex(primeiro => primeiro[index]) )
                );

            if ( info )
                return info[index];
        },

        upload() {
            var downloadAnchorNode = document.createElement('input');
            downloadAnchorNode.setAttribute("type", "file");
            downloadAnchorNode.setAttribute("class", "d-none");
            downloadAnchorNode.setAttribute("accept", ".csv, .txt, .xml");
            downloadAnchorNode.onchange = () => { this.posUpload(downloadAnchorNode); };
            document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
        },

        refresh_especial () { 
            this.$nextTick(() => { 
                this.refreshing = false;
                this.$forceUpdate();
            });
        },

        validar_colunas_exclusao (dados) {
            if ( !Array.isArray(dados) || !dados.length ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Arquivo inválido para exclusão: arquivo vazio ou inválido.",
                    life: 5000
                });

                this.origem = null;
                this.refreshing = false;
                return false;
            }

            const linhasInvalidas = [];

            dados.forEach((linha, idx) => {
                if ( !Array.isArray(linha) )
                    return;

                const linhaVazia = !linha.some(campo => String(campo || '').trim() !== '');

                if ( linhaVazia )
                    return;

                const totalColunas = linha.length;

                if ( totalColunas !== this.excluir_colunas_esperadas ) {
                    linhasInvalidas.push({
                        linha: idx + 1,
                        colunas: totalColunas,
                    });
                }
            });

            if ( linhasInvalidas.length ) {
                const primeiraInvalida = linhasInvalidas[0];

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Arquivo inválido para exclusão: esperado " + this.excluir_colunas_esperadas + " colunas. Linha " + primeiraInvalida.linha + " com " + primeiraInvalida.colunas + " colunas.",
                    life: 6000
                });

                this.origem = null;
                this.refreshing = false;
                return false;
            }

            return true;
        },

        posUpload(el) {
            var file = el.files[0];

            console.log('Upload realizado 2.');

            if (file) {

                // console.log('Arquivo', file);

                var reader = new FileReader();

                reader.readAsText(file, "UTF-8");

                reader.onload = (evt) => {
                    // remover caracteres especiais
                    // André decidiu não usar essa função pq o simpro e brasindice tem que vir no padrão UTF8
                    // let csvContent = evt.target.result;
                    // csvContent = csvContent.replace(/"(.*?)"/g, function(match) {
                    //     return match.replace(/[^\x20-\x7E]/g, '');
                    // });

                    let separador = ( this.separador ? this.separador : ';' );

                    if ( this.layout_selecionado && this.layout_selecionado.ch_tipo == '0' ) {
                        separador = "@@!@@!";
                    }

                    this.refreshing = true; 

                    CSV.readAll(evt.target.result, separador, dados => {
                        if ( this.is_excluir && !this.validar_colunas_exclusao(dados) ) {
                            return;
                        }

                        this.origem = dados;

                        if ( this.service == 'internacaos' ) {
                            this.$util.load(this, {
                                service: this.service,
                                func: 'layout_especial',
                                redir_api: true, 
                                parms: {
                                    csv: dados,
                                },
                                loadTo: res => {
                                    if ( res ) {
                                        this.campos = res;
                                    }
                                }
                            });
                        }

                        this.$nextTick(() => { 
                            this.refresh_especial(); 
                        });
                    });
                }

                reader.onerror = function () {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Falha lendo arquivo.",
                        life: 3000
                    });
                }

            } else {

                console.log('arquivo não encontrado.');

            }
        },
    },

}
</script>

